var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "19px",
    viewBox: "0 0 18 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "log-out") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-Dropdown",
    transform: "translate(-1226.000000, -303.000000)",
    fill: "#AF0909"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Drop-out",
    transform: "translate(1208.000000, 59.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "log-out",
    transform: "translate(18.000000, 244.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3323077,1.73076923 L12.3323077,3.24461538 C15.4254113,4.74951431 17.0698463,8.1907057 16.2976906,11.5426881 C15.5255349,14.8946706 12.5413074,17.2696129 9.10153846,17.2696129 C5.66176948,17.2696129 2.67754198,14.8946706 1.90538629,11.5426881 C1.13323059,8.1907057 2.77766564,4.74951431 5.87076923,3.24461538 L5.87076923,1.73076923 C1.95786848,3.28143991 -0.301443317,7.39344224 0.487897006,11.5277274 C1.27723733,15.6620125 4.89257518,18.6523946 9.10153846,18.6523946 C13.3105017,18.6523946 16.9258396,15.6620125 17.7151799,11.5277274 C18.5045202,7.39344224 16.2452084,3.28143991 12.3323077,1.73076923 L12.3323077,1.73076923 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.64,1.28307692 L8.64,8.78307692 C8.64,9.24461538 8.85230769,9.65076923 9.33230769,9.65076923 C9.81230769,9.65076923 10.0246154,9.26307692 10.0246154,8.78769231 L10.0246154,1.28307692 C10.0246154,0.821538462 9.81230769,0.42 9.33230769,0.42 C8.85230769,0.42 8.64,0.803076923 8.64,1.28307692 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log-out.9cb1721b0cc88c2a8a8496583a82c92d.svg";
export { ForwardRef as ReactComponent };